"use strict";
/**
 * `body` combinator: sets body on a `Req` and returns a `Req`.
 *
 * @since 3.0.0
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var E = __importStar(require("fp-ts/lib/Either"));
var RTE = __importStar(require("fp-ts/lib/ReaderTaskEither"));
var TU = __importStar(require("fp-ts/lib/Tuple"));
var pipeable_1 = require("fp-ts/lib/pipeable");
var index_1 = require("../index");
/**
 * Sets the provided `body` (automatically converted to string when JSON) on `Req` init object and returns the updated `Req`.
 *
 * @since 3.0.0
 */
function withBody(body) {
    return function (req) { return pipeable_1.pipe(toBodyInit(body), RTE.chain(setBody(req))); };
}
exports.withBody = withBody;
function setBody(req) {
    return function (body) {
        return pipeable_1.pipe(req, RTE.local(function (input) {
            return pipeable_1.pipe(index_1.normalizeReqInput(input), TU.mapLeft(function (init) { return (__assign({}, init, { body: body })); }));
        }));
    };
}
function toBodyInit(body) {
    return pipeable_1.pipe(RTE.ask(), RTE.chain(function (input) {
        return RTE.fromEither(pipeable_1.pipe(toStringWhenJSON(body), E.mapLeft(function (e) { return index_1.toRequestError(e, index_1.normalizeReqInput(input)); })));
    }));
}
function toStringWhenJSON(body) {
    if (Object.getPrototypeOf(body).constructor.name !== 'Object') {
        return E.right(body); // type assertion mandatory...
    }
    return E.stringifyJSON(body, E.toError);
}
//# sourceMappingURL=body.js.map